/**
 * Dashboard Page Hints
 *
 * Contextual hints for the business portal dashboard.
 * Targets elements tagged with `data-astor-id` on the dashboard page.
 */

import type { HintConfig } from './hint-config.types';

export const dashboardHints: HintConfig[] = [
  {
    id: 'dashboard-new-lead',
    targetAstorId: 'dashboard-new-lead-btn',
    title: 'hints.dashboard.newLead.title',
    description: 'hints.dashboard.newLead.description',
    portal: 'business',
    route: '/dashboard',
    showOnce: true,
    priority: 'high',
    variant: 'tip',
    placement: 'bottom',
  },
  {
    id: 'dashboard-new-case',
    targetAstorId: 'dashboard-new-case-btn',
    title: 'hints.dashboard.newCase.title',
    description: 'hints.dashboard.newCase.description',
    portal: 'business',
    route: '/dashboard',
    showOnce: true,
    priority: 'high',
    variant: 'tip',
    placement: 'bottom',
  },
  {
    id: 'dashboard-upload-doc',
    targetAstorId: 'dashboard-upload-doc-btn',
    title: 'hints.dashboard.uploadDoc.title',
    description: 'hints.dashboard.uploadDoc.description',
    portal: 'business',
    route: '/dashboard',
    showOnce: true,
    priority: 'medium',
    variant: 'info',
    placement: 'bottom',
  },
];
